import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from "../Services/translation";
import { wistlistUpdate } from '../Services/Cart.service';
import { loadError, update } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';

const AddToWishlistButton = ({ articleNumber: articleNumberProp, initialIsInWishlist = null }) => {

    const productArticleNumber = useSelector((state) => state.product.currentArticleNumber);
    const articleNumber = articleNumberProp || productArticleNumber;
    const [isActive, setIsInWishlist] = useState(initialIsInWishlist === true);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!articleNumber || initialIsInWishlist !== null) {
            return;
        }

        function getData() {
            fetch("/api/cart/isinwishlist", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ articleNumber: articleNumber }),
            })
                .then(response => response.json())
                .then(json => setIsInWishlist(json));
        }

        getData();

    }, [articleNumber, initialIsInWishlist]);

    const onClick = async () => {

        try {
            var added = await wistlistUpdate({ articleNumber });
            console.log(added);
            setIsInWishlist(added);

            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };

    return (
        <Fragment>
            <a className="table__icon"
                title={translate(`general.add.remove`)}
                onClick={(e) => {
                    e.preventDefault();
                    onClick();
                }}
            >
                <i id="addToWishlist" className={isActive ? "wishlist__icon__filled" : "wishlist__icon"}></i>
            </a>
        </Fragment>
    );
};

export default AddToWishlistButton;
